import { useEffect, useState } from 'react';
import { AppState } from '@landr/auth';
import { attemptedActionStore } from '../../helpers/attemptedActionStore';
import useHandleAttemptedAction from './hooks';

/*
 * There are numerous actions throughout the app that unauthenticated users
 * (guests) are allowed to attempt, but which will not be completed until they
 * have signed up or authenticated.
 *
 * When a guest attempts a gated action (add to favorites, add to collection, etc.)
 * that action is saved in session storage and then retrieved upon returning to the page
 * so it can be continued.
 */
export function usePostAuthenticationActionController({
    appState,
    isAuthenticated,
    isAuthenticationLoading,
    isSignup,
}: {
    appState: AppState | null;
    isAuthenticated: boolean;
    isAuthenticationLoading: boolean;
    isSignup: boolean;
}) {
    const [didRun, setDidRun] = useState(false);
    const handleAttemptedAction = useHandleAttemptedAction();

    useEffect(() => {
        // Wait for Feature Flags and Authentication to resolve before performing
        // the stashed action

        if (!isSignup && !didRun && !isAuthenticationLoading) {
            const attemptedAction = attemptedActionStore.get();

            setDidRun(true);

            if (attemptedAction && isAuthenticated) {
                attemptedActionStore.remove();
                handleAttemptedAction(attemptedAction);
            }
        }
    }, [
        appState,
        handleAttemptedAction,
        didRun,
        isAuthenticated,
        isAuthenticationLoading,
        isSignup,
    ]);
}
